import React, { useState, useEffect } from "react";
import { Input } from "antd";

const InformationForm = ({ 
  payload, 
  handlePayloadChange, 
  category, 
  response 
}) => {
  const [text, setText] = useState("");

   useEffect(() => {
    if ((category === "editInformation" || category === "addInformation") && payload){
      setText(payload.text || "");
    }
  }, [payload, response, category])

  const handleChange = (e, type) => {
    if (type === "text") {
      setText(e.target.value);
      handlePayloadChange({...payload, text: e.target.value});
    }
  }
  return (
    <div>
      <label>Information (tooltip)</label>
      <Input 
        value={text}
        defaultValue={text}
        onChange={(e) => handleChange(e, "text")}
      />
    </div>
  )
}

export default InformationForm;